module.exports = __webpack_public_path__ + "static/media/broadcast-tower.df26bfd6.svg";